<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          :class="{active: tab==='basic'}"
          @click="tab='basic'"
        >Basic</a>
      </li>
      <li class="nav-item">
        <span class="divider">|</span>
      </li>
      <li class="nav-item">
        <a
          :class="{active: tab==='advanced'}"
          @click="tab='advanced'"
        >Advanced</a>
      </li>
    </ul>
    <div
      v-show="tab==='basic'"
      id="basic"
    >
      <div class="row">
        <div class="col-md-6">
          <h2>Basic Validation</h2>
        </div>
        <div class="col-md-6 text-right">
          <button
            id="basicValidation"
            class="btn btn-primary btn-lg"
            :disabled="loadingStatus"
            @click="loadValidation()"
          >
            Run Again
          </button>
        </div>
      </div>
      <div
        v-if="loadingStatus"
        class="row"
      >
        <div class="col-sm-12">
          <empty-state
            icon="tasks"
            description="Basic Validation test is in progress"
          />
        </div>
      </div>
      <div v-if="!loadingStatus">
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.images.Issues"
              :title="imageLength"
              description="Images"
              :icon="imageIcon"
              :icon-color="imageColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.links.Issues"
              :title="linkLength"
              description="Links"
              :icon="linksIcon"
              :icon-color="linksColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.unwantedHtmlTags.Issues"
              :title="unwantedHtmlTagsLength"
              description="Unwanted HTML Tags"
              :icon="unwantedHtmlTagsIcon"
              :icon-color="unwantedHtmlTagsColor"
            />
          </div>
          <div class="col-lg-3 col-md-6">
            <info-card
              v-if="info.microsoftWordTags.Issues"
              :title="microsoftWordTagsLength"
              description="Microsoft Word Tags"
              :icon="microsoftWordTagsIcon"
              :icon-color="microsoftWordTagsColor"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <Card
              icon="image"
              title="Images"
              toggle
            >
              <ul class="links">
                <li
                  v-for="(img, index) in info.images.Info"
                  :key="'image-info-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="img"
                    status="Valid"
                    tip-pointer-position="Middle"
                    type="image"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="success"
                    />
                    <a
                      href="javascript:void(0)"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                    >{{ img }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(img, index) in info.images.Issues"
                  :key="'image-issues-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="img"
                    status="Not Found"
                    tip-pointer-position="Middle"
                    type="image"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="danger"
                    />
                    <a
                      href="javascript:void(0)"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                    >{{ img | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
              </ul>
            </Card>
            <Card
              icon="link"
              title="Links"
              toggle
            >
              <ul class="links">
                <li
                  v-for="(link, index) in info.links.Info"
                  :key="'link-info-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Valid"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="success"
                    />
                    <a
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(link, index) in info.links.Issues"
                  :key="'link-issues-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Not Accessible"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="warning"
                    />
                    <a
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
                <li
                  v-for="(link, index) in info.links.Errors"
                  :key="'link-errors-' + index"
                >
                  <ejs-tooltip
                    ref="tooltip"
                    :content="tooltipTemplate"
                    :css-class="cssClass"
                    position="BottomCenter"
                    opens-on="Hover"
                    :link="link"
                    status="Error"
                    tip-pointer-position="Middle"
                    type="link"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'circle']"
                      size="xs"
                      class="danger"
                    />
                    <a
                      :href="link|cleanURL"
                      data-toggle="tooltip"
                      class="tooltip-links"
                      data-placement="bottom"
                      target="_blank"
                    >{{ link | cleanURL }}</a>
                  </ejs-tooltip>
                </li>
              </ul>
            </Card>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <Card
              icon="ban"
              title="Spam Assassin"
            >
              <table class="table-list table-list-lines spam-assassin-table">
                <tr>
                  <td class="table-list--title">
                    Administrator
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.administrator"
                  :key="'admin-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    Body
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.body"
                  :key="'body-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    Informational
                  </td>
                </tr>
                <tr
                  v-for="(admin,index) in info.translatedSpamCheck.informational"
                  :key="'informational-' + index"
                  class="border-bottom"
                >
                  <td class="table-list--subtitle">
                    {{ admin.description }}
                  </td>
                  <td>{{ admin.point }}</td>
                </tr>
                <tr>
                  <td class="table-list--title">
                    <strong>Total</strong>
                  </td>
                  <td :class="{'text-success': info.translatedSpamCheck.total < 5}">
                    {{ info.translatedSpamCheck.total }}
                  </td>
                </tr>
              </table>
            </Card>
          </div>
          <div class="col-sm-6">
            <Card
              icon="code"
              title="Unwanted HTML Tags"
            >
              <p v-if="info.microsoftWordTags.Issues && !info.unwantedHtmlTags.Issues.length">
                No tags found
              </p>
              <ul v-if="info.microsoftWordTags.Issues && info.unwantedHtmlTags.Issues.length">
                <li
                  v-for="(tag, index) in info.unwantedHtmlTags.Issues"
                  :key="'html' + index"
                >
                  {{ tag }}
                </li>
              </ul>
            </Card>
            <Card
              icon="file"
              title="Microsoft Word Tags"
            >
              <p v-if="info.microsoftWordTags.Issues && !info.microsoftWordTags.Issues.length">
                No tags found
              </p>
              <ul v-if="info.microsoftWordTags.Issues && info.microsoftWordTags.Issues.length">
                <li
                  v-for="(tag, index) in info.microsoftWordTags.Issues"
                  :key="'word' + index"
                >
                  {{ tag }}
                </li>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tab==='advanced'"
      id="advanced"
    >
      <div class="row">
        <div class="col-sm-6">
          <Card
            icon="code"
            title="Inbox Preview"
          >
            <div
              v-if="!inboxPreviewAndForecaster.inboxPreviews || inboxPreviewAndForecaster.inboxPreviews.length === 0"
              class="empty-state"
            >
              <p class="empty-state-icon">
                <font-awesome-icon :icon="['fal', 'grip-horizontal']" />
              </p>
              <h4>Inbox Preview</h4>
              <p class="empty-state-text">
                Review desktop and mobile devices in popular email clients to spot rendering problems before sending.
              </p>
              <p
                v-if="getCampaign && getCampaign.isAdrEnabled"
                class="empty-state-button"
                @click="requestInboxPreview"
              >
                <button class="btn btn-lg btn-primary">
                  Request
                </button>
              </p>
            </div>
            <table
              v-if="inboxPreviewAndForecaster.inboxPreviews && inboxPreviewAndForecaster.inboxPreviews.length > 0"
              class="table-list table-list-lines"
            >
              <tr
                v-for="(preview, index) in inboxPreviewAndForecaster.inboxPreviews"
                :key="'preview-' + index"
                class="border-bottom"
              >
                <td>
                  <p class="table-list--title">
                    {{ preview.subject }}
                  </p>
                  <p class="table-list--subtitle">
                    {{ preview.requestedDate | dateFormat }}
                  </p>
                </td>
                <td>
                  <a
                    :href="preview.url"
                    class="btn btn-lg btn-border"
                    target="_blank"
                  >Launch</a>
                </td>
              </tr>
              <tr v-if="getCampaign && getCampaign.isAdrEnabled">
                <td colspan="2">
                  <a
                    href="javascript:void(0)"
                    @click="requestInboxPreview"
                  ><font-awesome-icon
                    id="inboxPreview"
                    :icon="['far', 'plus-circle']"
                  /> Request New Test</a>
                </td>
              </tr>
            </table>
          </Card>
        </div>
        <div
          v-if="isInboxForecasterEnabled && isInboxForecasterEnabled.settingValue != '0' && userAccessControl && !userAccessControl.DeliveryReport"
          class="col-sm-6"
        >
          <Card
            icon="binoculars"
            title="Inbox Forecaster"
          >
            <div
              v-if="!inboxPreviewAndForecaster.inboxForecasters || inboxPreviewAndForecaster.inboxForecasters.length === 0"
              class="empty-state"
            >
              <p class="empty-state-icon">
                <font-awesome-icon :icon="['fal', 'window']" />
              </p>
              <h4>Inbox Forecast</h4>
              <p class="empty-state-text">
                Estimate the success of your campaign reaching your guests' inboxes before sending.
              </p>
              <p
                v-if="getCampaign && getCampaign.isAdrEnabled"
                class="empty-state-button"
                @click="requestInboxForecaster"
              >
                <button
                  id="advancedDeliverability"
                  class="btn btn-lg btn-primary"
                >
                  Request
                </button>
              </p>
            </div>
            <table
              v-if="inboxPreviewAndForecaster.inboxForecasters && inboxPreviewAndForecaster.inboxForecasters.length > 0"
              class="table-list table-list-lines table-inbox-preview-forecaster"
            >
              <tr
                v-for="(forecaster, index) in inboxPreviewAndForecaster.inboxForecasters"
                :key="'forecaster-' + index"
                class="border-bottom"
              >
                <td>
                  <p class="table-list--title">
                    {{ forecaster.subject }}
                  </p>
                  <p class="table-list--subtitle">
                    {{ forecaster.requestedDate | dateFormat }}
                  </p>
                </td>
                <td>
                  <a
                    :href="forecaster.url"
                    class="btn btn-lg btn-border"
                    target="_blank"
                  >Launch</a>
                </td>
              </tr>
              <tr v-if="getCampaign && getCampaign.isAdrEnabled">
                <td colspan="2">
                  <a
                    href="javascript:void(0)"
                    @click="requestInboxForecaster"
                  ><font-awesome-icon
                    id="inboxPreview"
                    :icon="['far', 'plus-circle']"
                  /> Request New Forecast</a>
                </td>
              </tr>
            </table>
          </Card>
        </div>
      </div>
    </div>
    <ejs-toast
      ref="requestForecasterRef"
      title="Request Inbox Forecaster"
      content="Your Inbox Forecaster will be available shortly"
      :position="toastPosition"
    />
    <ejs-toast
      ref="requestPreviewRef"
      title="Request Inbox Preview"
      content="Your Inbox Preview will be available shortly"
      :position="toastPosition"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import InfoCard from '../components/InfoCard'
import Card from '../components/Card'
import EmptyState from '../components/EmptyState'
import { iframeParentCommunication } from '../mixins/iframeParentCommunication'

const tooltipTemplate = Vue.component('TooltipTemplate', {
  data () {
    return {
      data: '',
      color: '',
      status: '',
      type: ''
    }
  },
  mounted () {
    this.data = this.$parent.$attrs.link
    this.status = this.$parent.$attrs.status
    if (this.status === 'Valid' || this.status === 'Info') {
      this.color = 'success'
    } else if (this.status === 'Not Found' || this.status === 'Error') {
      this.color = 'danger'
    } else {
      this.color = 'warning'
    }
    this.type = this.$parent.$attrs.type
  },
  methods: {
  },
  template: `<div>
              <p class="testing-img" v-if='this.status === "Valid" && this.type ==="image"'><img :src="data"></p>
              <p><svg data-v-57ab6f42="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-circle fa-w-16 fa-xs" :class='color'><path data-v-57ab6f42="" fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg> {{status}}</p>
              <a :href="data" target="_blank">{{data | cleanURL}}</a>
            </div>`
})

export default {
  name: 'CampaignDetailsTesting',
  components: {
    InfoCard,
    Card,
    EmptyState
  },
  mixins: [iframeParentCommunication],
  data () {
    return {
      tab: 'basic',
      cssClass: 'testing-tooltip',
      info: {
        images: {},
        links: {},
        unwantedHtmlTags: {},
        microsoftWordTags: {},
        spamCheck: {},
        translatedSpamCheck: {}
      },
      tooltipTemplate () {
        return {
          template: tooltipTemplate
        }
      },
      toastPosition: { X: 'Right', Y: 'Top' }
    }
  },
  computed: {
    ...mapGetters({
      validation: 'getCampaignBasicValidation',
      loadingStatus: 'getLoadingStatus',
      validationByType: 'getCampaignValidationByType',
      inboxPreviewAndForecaster: 'getCampaignInboxPreviewAndForecaster',
      getCampaign: 'getCampaignSummary',
      validationCampaignId: 'getValidationCampaignId',
      isInboxForecasterEnabled: 'getIsInboxForecasterEnabled',
      userAccessControl: 'getUserAccessControl'
    }),
    imageLength () {
      return this.info.images.Issues.length + this.info.images.Info.length + this.info.images.Errors.length
    },
    linkLength () {
      return this.info.links.Info.length + this.info.links.Issues.length + this.info.links.Errors.length
    },
    unwantedHtmlTagsLength () {
      return this.info.unwantedHtmlTags.Info.length + this.info.unwantedHtmlTags.Issues.length + this.info.unwantedHtmlTags.Errors.length
    },
    microsoftWordTagsLength () {
      return this.info.microsoftWordTags.Info.length + this.info.microsoftWordTags.Issues.length + this.info.microsoftWordTags.Errors.length
    },
    imageIcon () {
      return this.info.images.Issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    imageColor () {
      return this.info.images.Issues.length > 0 ? 'danger' : 'success'
    },
    linksIcon () {
      return this.info.links.Errors.length > 0 || this.info.links.Issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    linksColor () {
      if (this.info.links.Errors.length > 0) {
        return 'danger'
      } else if (this.info.links.Issues.length > 0) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    unwantedHtmlTagsIcon () {
      return this.info.unwantedHtmlTags.Errors.length > 0 || this.info.unwantedHtmlTags.Issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    unwantedHtmlTagsColor () {
      return this.info.unwantedHtmlTags.Errors.length > 0 || this.info.unwantedHtmlTags.Issues.length > 0 ? 'danger' : 'success'
    },
    microsoftWordTagsIcon () {
      return this.info.microsoftWordTags.Errors.length > 0 || this.info.microsoftWordTags.Issues.length > 0 ? 'exclamation-circle' : 'check-circle'
    },
    microsoftWordTagsColor () {
      return this.info.microsoftWordTags.Errors.length > 0 || this.info.microsoftWordTags.Issues.length > 0 ? 'danger' : 'success'
    }
  },
  watch: {
    validation (val) {
      this.renderValidation()
    }
  },
  mounted () {
    if ((this.$route.query.campaignId && this.validation.length === 0) || this.validationCampaignId !== this.$route.query.campaignId) {
      this.$store.dispatch('setCampaignBasicValidation', { projectId: this.$route.query.campaignId })
      this.$store.dispatch('setCampaignInboxPreviewAndForecaster', { projectId: this.$route.query.campaignId })
    } else {
      this.renderValidation()
    }
    console.log('isInboxForecasterEnabled: ', this.isInboxForecasterEnabled)
    console.log('userAccessControl: ', this.userAccessControl)
  },
  methods: {
    renderValidation () {
      this.info.images = this.validationFilter('ImagesExistTest')[0]
      this.info.links = this.validationFilter('LinksValidTest')[0]
      this.info.unwantedHtmlTags = this.validationFilter('BadHtmlTagsTest')[0]
      this.info.microsoftWordTags = this.validationFilter('MsWordHtmlTest')[0]
      this.info.spamCheck = this.validationFilter('PostmarkSpamCheck')[0]
      this.filterSpamAssassin()
    },
    requestInboxPreview () {
      if (this.$route.query.campaignId) {
        this.$store.dispatch('requestCampaignInboxPreview', { projectId: this.$route.query.campaignId })
          .then(response => {
            this.$store.dispatch('setCampaignInboxPreviewAndForecaster', { projectId: this.$route.query.campaignId })
            console.log(response)
            const data = {
              action: 'eIn_show_alert',
              value: {
                headline: 'Success',
                message: 'Your Inbox Preview will be available shortly.',
                type: 'success'
              }
            }
            this.SendMessageToParent(data)
            // this.$refs.requestPreviewRef.show()
          })
      }
    },
    requestInboxForecaster () {
      if (this.$route.query.campaignId) {
        this.$store.dispatch('requestCampaignInboxForecaster', { projectId: this.$route.query.campaignId })
          .then(response => {
            this.$store.dispatch('setCampaignInboxPreviewAndForecaster', { projectId: this.$route.query.campaignId })
            console.log(response)
            const data = {
              action: 'eIn_show_alert',
              value: {
                headline: 'Success',
                message: 'Your Inbox Forecaster will be available shortly.',
                type: 'success'
              }
            }
            this.SendMessageToParent(data)
            // this.$refs.requestForecasterRef.show()
          })
      }
    },
    validationFilter (value) {
      return this.validationByType(value)
    },
    loadValidation () {
      if (this.$route.query.campaignId) {
        this.$store.dispatch('setCampaignBasicValidation', { projectId: this.$route.query.campaignId })
      }
    },
    filterSpamAssassin () {
      const data = this.info.spamCheck
      const spamCheck = { body: [], informational: [], administrator: [], total: '' }
      if (data.Info[0]) {
        let total = data.Info[0].substring(data.Info[0].lastIndexOf(' ') + 1)
        total = total.replace(/.\s*$/, '')
        spamCheck.total = total
        for (let i = 0; i < data.Issues.length; i++) {
          const str = data.Issues[i]
          const type = str.match(/points:\s(\w*)/, ' ')
          if (type[1] === 'BODY') {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.body.push({ description: result, point: point })
          } else if (type[1] === 'Informational') {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.informational.push({ description: result, point: point })
          } else {
            const result = str.substring(str.lastIndexOf(': ') + 1)
            const point = str.substring(0, str.indexOf(' points:'))
            spamCheck.administrator.push({ description: result, point: point })
          }
        }
      }
      this.info.translatedSpamCheck = spamCheck
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css";
@import "../../node_modules/@syncfusion/ej2-vue-notifications/styles/bootstrap4.css";
.nav-tabs {
  border-bottom: none;
}
.nav-item {
  margin-bottom: 20px;
  .divider {
    margin: 0 8px;
  }
  a {
    color: $blue-dark;
    text-decoration: none;
    &:hover {
      cursor: pointer;
    }
    &.active {
      text-decoration: underline;
    }
  }
}
.links li {
  padding: 14px 0;
  a {
    margin-left: 6px;
    font-size: 1.4rem;
  }
}
a {
  text-decoration: none;
}
.btn-lg {
  font-size: 1.5rem !important;
}
.campaign-empty-state {
  text-align: center;
  svg {
    color: $secondary-light;
  }
}
#basicValidation {
  margin-bottom: 20px;
}
table.spam-assassin-table {
  tr td:first-child {
    width: 75%;
  }
}
.empty-state {
  .empty-state-icon {
    font-size: 6.4rem;
  }
  h4 {
    font-size: 1.8rem;
  }
  .empty-state-text {
    font-size: 1.6rem;
    margin-bottom: 20px;
    text-align: center;
  }
}

</style>
